import { Schema } from 'jsonschema'
import { schemaOf } from '@rezonence/schema-transformer'
import { ImporterQueryParams } from './ImporterQueryParams'

export const importerQueryParamsSchema: Schema = schemaOf<ImporterQueryParams>()
